// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/Exit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-polaznici {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280a;
  border-radius: 8px;
}

.table-polaznici-row,
.table-polaznici-avatar,
.table-polaznici-button {
  display: flex;
  align-items: center;
}
.table-polaznici-column {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  width: 100%;
}
.table-polaznici-row {
  gap: 16px;
}

.table-polaznici-row:hover {
  cursor: pointer;
}

.table-polaznici-row,
.table-polaznici-avatar {
  justify-content: flex-start;
}
.table-polaznici th,
.table-polaznici td {
  padding-left: 16px;
  padding-right: 16px;
  text-align: left;
  border-bottom: 1px solid #d1d9e2;
}

.table-polaznici tr:last-child {
  border-bottom: none;
}

.table-polaznici th,
.table-polaznici tr {
  text-align: left;
  font-family: Inter;
  font-size: 16px;
}
.table-polaznici th {
  color: #5f6d7ec7;
  font-weight: 600;
  padding: 16px;
  background-color: #f8f9fb;
}
.table-polaznici tr {
  font-weight: 500;
}

.table-polaznici-avatar img {
  width: 32px;
  height: 32px;
  border-radius: 100px;
  object-fit: cover;
}

.table-polaznici-button {
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 50%;
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
  background-color: #e2e2e2;
  border-radius: 39px;
  width: 24px;
  height: 24px;
  border: none;
  transition: backgroundColor 300ms ease-in-out;
}

.table-polaznici-button:hover,
.table-polaznici-add-btn:hover {
  background-color: #d1d9e2;
  cursor: pointer;
}

.table-polaznici-btn-container,
.table-polaznici-add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-polaznici-btn-container {
  background-color: #f8f9fb;
  padding-top: 16px;
  padding-bottom: 16px;
  border-left: 1px solid #d1d9e2;
  border-right: 1px solid #d1d9e2;
  border-bottom: 1px solid #d1d9e2;
}

.table-polaznici-add-btn {
  background-color: white;
  height: 40px;
  border: 1px solid #d1d9e2;
  transition: backgroundColor 300ms ease-in-out;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
  border-radius: 4px;
  color: #5f6d7e;
  gap: 8px;
  padding: 8px 16px 8px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/FakultativnaRadionicaEditCreate/PolazniciTable/TablePolaznici.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yDAAqD;EACrD,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,0BAA0B;AAC5B","sourcesContent":[".table-polaznici {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 10px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280a;\n  border-radius: 8px;\n}\n\n.table-polaznici-row,\n.table-polaznici-avatar,\n.table-polaznici-button {\n  display: flex;\n  align-items: center;\n}\n.table-polaznici-column {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  width: 100%;\n}\n.table-polaznici-row {\n  gap: 16px;\n}\n\n.table-polaznici-row:hover {\n  cursor: pointer;\n}\n\n.table-polaznici-row,\n.table-polaznici-avatar {\n  justify-content: flex-start;\n}\n.table-polaznici th,\n.table-polaznici td {\n  padding-left: 16px;\n  padding-right: 16px;\n  text-align: left;\n  border-bottom: 1px solid #d1d9e2;\n}\n\n.table-polaznici tr:last-child {\n  border-bottom: none;\n}\n\n.table-polaznici th,\n.table-polaznici tr {\n  text-align: left;\n  font-family: Inter;\n  font-size: 16px;\n}\n.table-polaznici th {\n  color: #5f6d7ec7;\n  font-weight: 600;\n  padding: 16px;\n  background-color: #f8f9fb;\n}\n.table-polaznici tr {\n  font-weight: 500;\n}\n\n.table-polaznici-avatar img {\n  width: 32px;\n  height: 32px;\n  border-radius: 100px;\n  object-fit: cover;\n}\n\n.table-polaznici-button {\n  justify-content: center;\n  background-image: url(\"../../../assets/img/Exit.png\");\n  background-size: 50%;\n  background-position-x: center;\n  background-position-y: center;\n  background-repeat: no-repeat;\n  background-color: #e2e2e2;\n  border-radius: 39px;\n  width: 24px;\n  height: 24px;\n  border: none;\n  transition: backgroundColor 300ms ease-in-out;\n}\n\n.table-polaznici-button:hover,\n.table-polaznici-add-btn:hover {\n  background-color: #d1d9e2;\n  cursor: pointer;\n}\n\n.table-polaznici-btn-container,\n.table-polaznici-add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.table-polaznici-btn-container {\n  background-color: #f8f9fb;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  border-left: 1px solid #d1d9e2;\n  border-right: 1px solid #d1d9e2;\n  border-bottom: 1px solid #d1d9e2;\n}\n\n.table-polaznici-add-btn {\n  background-color: white;\n  height: 40px;\n  border: 1px solid #d1d9e2;\n  transition: backgroundColor 300ms ease-in-out;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n  border-radius: 4px;\n  color: #5f6d7e;\n  gap: 8px;\n  padding: 8px 16px 8px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
